
/**
* @name planning
* @autor over.martinez@u-planner.com
* @description : something
* # planning
* @name factory: strategicTrackingListSrv
*/

class strategicTrackingListSrv {
   
	constructor($resource,SERVICE_URL_CONSTANT) {

		var addNotificationsTransactions = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactions', {}, {
			add: {
				method: 'POST'
			}
		})

		return {
			addNotificationsTransactions: addNotificationsTransactions,
			list: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:idModule/:idAcaUnit/:userId/:roleId/:planId/:stateId', {}, {
				getAcademicUnit: {
					method: "GET",
					params: {
					   type: "academic_unit", 
					   route: "getAcademicUnit"
					}
				},
				getDataTeacher: {
					method: "GET",
					params: {
					   type: "strategic_tracking", 
					   route: "getDetailTeacherByUASubmodule"
					}
				},
			}),
			data: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:idModule/:idAcaUnit/:userId/:roleId/:stateId', {}, {
				getDataGrid: {
					method: "GET",
					params: {
					   type: "strategic_tracking", 
					   route: "getCountStatesBySubmoduleDetail"
					}
				},
				getDataChart: {
					method: "GET",
					params: {
					   type: "strategic_tracking", 
					   route: "getCountStatesBySubmodule"
					}
				},
			}),
			chart: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:idAcaUnit/:userId/:roleId', {}, {
				getDataChartTotal: {
					method: "GET",
					params: {
					   type: "strategic_tracking", 
					   route: "getCountTotalBySubmodule"
					}
				},
			}),
			tracking: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route', {}, {
				remove: {
					method: "POST",
					params: {
					   type: "activity", 
					   route: "setStrategicTracingActivity"
					}
				},
				plansByEvaluator: {
					method: "POST",
					params: {
					   type: "strategic_tracking", 
					   route: "getWorkPlan"
					}
				},
				getSummaryActivities: {
					method: "POST",
					params: {
					   type: "strategic_tracking", 
					   route: "getSummaryActivities"
					}
				},
			}),
			save: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:roleId', {}, {
				bitacora: {
					method: "POST",
					params: {
					   type: "strategic_tracking", 
					   route: "getSaveActivitiesEntries"
					}
				},
			}),
			get: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:roleId', {}, {
				plans: {
					method: "POST",
					params: {
					   type: "teacher", 
					   route: "getAllWokplanByTeacher"
					}
				},
				states: {
					method: "GET",
					params: {
					   type: "strategic_tracking", 
					   route: "getListStates"
					}
				},
				typeRole: {
					method: "GET",
					params: {
					   type: "strategic_tracking", 
					   route: "getUserTypeRoles"
					}
				},
				details: {
					method: "POST",
					params: {
					   type: "activity", 
					   route: "getActivitiesDetail"
					}
				},
				acaDetails: {
					method: "POST",
					params: {
					   type: "activity", 
					   route: "getActivityDetailAcademic"
					}
				},
				consDetails: {
					method: "POST",
					params: {
					   type: "activity", 
					   route: "getActivityDetailTeachingStaff"
					}
				},
				entries: {
					method: "POST",
					params: {
					   type: "strategic_tracking", 
					   route: "getActivitiesEntries"
					}
				},
				workPlan: {
					method: "POST",
					params: {
					   type: "general", 
					   route: "getWorkPlanGeneral"
					}
				},
				activities: {
					method: "POST",
					params: {
					   type: "strategic_tracking",
					   route: "getActivitiesPlanning"
					}
				},
				actAcademics: {
					method: "POST",
					params: {
					   type: "strategic_tracking",
					   route: "getActivityPlanningAcademic"
					}
				},
				actExtension: {
					method: "POST",
					params: {
					   type: "strategic_tracking",
					   route: "getActivityExtesion"
					}
				},
				actInvestigation: {
					method: "POST",
					params: {
					   type: "strategic_tracking",
					   route: "getActivityinvestigation"
					}
				},
				actConsolidation: {
					method: "POST",
					params: {
					   type: "strategic_tracking",
					   route: "getActivityConsolidation"
					}
				},
			})
		}

	}
}

strategicTrackingListSrv.$inject=['$resource','SERVICE_URL_CONSTANT']

export default angular.module('services.strategicTrackingListSrv', [])
.service('strategicTrackingListSrv', strategicTrackingListSrv)
.name;


// WEBPACK FOOTER //
// ./src/app/u-faculty/strategicTracking/strategicTrackingListSrv.js